<div class="container mx-auto px-4">

  <!-- Barre d'outils : filtre uniquement (pas de bouton "Demander") -->
  <div class="bg-white rounded-lg p-4 mb-2">
    <div class="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center">
      <div class="relative w-full sm:w-52">
        <select [(ngModel)]="selectedStatus" (ngModelChange)="onStatusFilterChange()"
          class="w-full h-11 px-4 pr-10 bg-white border border-gray-300 rounded-lg text-sm appearance-none
                 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 cursor-pointer">
          <option value="">Tous les statuts</option>
          <option value="PENDING">En attente</option>
          <option value="APPROVED">Approuvé</option>
          <option value="REJECTED">Refusé</option>
        </select>
        <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
          <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clip-rule="evenodd"/>
          </svg>
        </div>
      </div>

      <!-- Compteur rapide -->
      <div class="flex gap-3 text-sm">
        <span class="flex items-center gap-1.5 px-3 py-1 bg-yellow-50 text-yellow-700 rounded-full border border-yellow-200">
          <span class="w-2 h-2 rounded-full bg-yellow-500"></span>
          {{ countByStatus('PENDING') }} en attente
        </span>
      </div>
    </div>
  </div>

  <!-- Message d'erreur -->
  <div *ngIf="error" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg mb-4 flex items-center justify-between">
    <span>{{ error }}</span>
    <button (click)="loadLeaves()" class="text-sm font-medium underline ml-4">Réessayer</button>
  </div>

  <!-- Tableau -->
  <div class="bg-white rounded-lg shadow-lg overflow-hidden">
    <div class="overflow-x-auto">

      <!-- En-tête -->
      <div class="grid grid-cols-6 gap-4 px-6 py-4 border-b bg-gray-50 min-w-[800px]">
        <div class="col-span-2 font-semibold text-gray-700 text-sm">Salarié</div>
        <div class="font-semibold text-gray-700 text-sm">Période</div>
        <div class="font-semibold text-gray-700 text-sm">Motif</div>
        <div class="font-semibold text-gray-700 text-sm">Statut</div>
        <div class="font-semibold text-gray-700 text-sm text-center">Actions</div>
      </div>

      <!-- Chargement -->
      <div *ngIf="isLoading" class="px-6 py-12 text-center">
        <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
        <p class="mt-2 text-gray-500 text-sm">Chargement des congés...</p>
      </div>

      <!-- Lignes -->
      <div *ngIf="!isLoading" class="min-h-[400px] min-w-[800px]">
        <div *ngFor="let leave of leaves"
          class="grid grid-cols-6 gap-4 px-6 py-4 border-b items-center hover:bg-gray-50 transition-colors">

          <!-- Salarié -->
          <div class="col-span-2">
            <p class="text-sm font-semibold text-gray-900">{{ getWorkerName(leave) }}</p>
            <p class="text-xs text-gray-400 mt-0.5">Demande le {{ formatDate(leave.createdAt) }}</p>
          </div>

          <!-- Période -->
          <div class="text-sm">
            <div class="font-medium text-gray-800">{{ formatDate(leave.startDate) }}</div>
            <div class="text-gray-500">→ {{ formatDate(leave.endDate) }}</div>
            <div class="text-xs text-gray-400 mt-0.5">
              {{ leave.requestedDays }} jour{{ leave.requestedDays > 1 ? 's' : '' }}
            </div>
          </div>

          <!-- Motif -->
          <div class="text-sm text-gray-600 truncate" [title]="leave.reason">
            {{ leave.reason || '-' }}
          </div>

          <!-- Statut + commentaire manager -->
          <div class="space-y-1">
            <span class="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-full"
              [ngClass]="getStatusBadgeClass(leave.status)">
              <span class="w-1.5 h-1.5 rounded-full flex-shrink-0" [ngClass]="getStatusDotClass(leave.status)"></span>
              {{ getStatusLabel(leave.status) }}
            </span>
            <p *ngIf="leave.managerComment" class="text-xs text-gray-400 truncate" [title]="leave.managerComment">
              {{ leave.managerComment }}
            </p>
            <p *ngIf="leave.reviewedByName" class="text-xs text-gray-400">
              par {{ leave.reviewedByName }}
            </p>
          </div>

          <!-- Actions -->
          <div class="flex justify-center gap-2">
            <ng-container *ngIf="leave.status === 'PENDING'">
              <!-- Approuver -->
              <button (click)="openReviewModal(leave, 'APPROVED')"
                class="flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-green-700 bg-green-50
                       border border-green-200 rounded-lg hover:bg-green-100 transition-colors whitespace-nowrap">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                </svg>
                Approuver
              </button>
              <!-- Refuser -->
              <button (click)="openReviewModal(leave, 'REJECTED')"
                class="flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-red-700 bg-red-50
                       border border-red-200 rounded-lg hover:bg-red-100 transition-colors whitespace-nowrap">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
                Refuser
              </button>
            </ng-container>

            <!-- Déjà traité -->
            <span *ngIf="leave.status !== 'PENDING'" class="text-xs text-gray-400 italic">
              Traité
            </span>
          </div>
        </div>

        <!-- Vide -->
        <div *ngIf="leaves.length === 0" class="px-6 py-14 text-center text-gray-500">
          <svg class="w-14 h-14 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
          </svg>
          <p class="text-base font-medium">Aucune demande de congé</p>
          <p class="mt-1 text-sm text-gray-400">
            {{ selectedStatus ? 'Aucune demande avec ce statut.' : 'Les salariés peuvent soumettre des demandes depuis l\'application mobile.' }}
          </p>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div *ngIf="totalElements > 0" class="px-6 py-4 flex items-center justify-between border-t bg-gray-50">
      <span class="text-sm text-gray-600">{{ getPaginationText() }}</span>
      <div class="flex items-center space-x-2">
        <button *ngIf="hasPreviousPage()" (click)="previousPage()"
          class="px-4 py-2 rounded-lg hover:bg-gray-100 text-orange-500 font-medium flex items-center gap-2 transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
          </svg>
          Précédent
        </button>
        <button *ngFor="let page of getPageNumbers()" (click)="goToPage(page)"
          [class]="page === currentPage
            ? 'w-10 h-10 rounded-lg bg-orange-500 text-white font-semibold flex items-center justify-center shadow-sm'
            : 'w-10 h-10 rounded-lg hover:bg-gray-100 text-gray-600 font-medium flex items-center justify-center transition-colors'">
          {{ page }}
        </button>
        <button *ngIf="hasNextPage()" (click)="nextPage()"
          class="px-4 py-2 rounded-lg hover:bg-gray-100 text-orange-500 font-medium flex items-center gap-2 transition-colors">
          Suivant
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>


<!-- ══════════════════════════════════════════════════════════════════════════ -->
<!--  POPUP — Confirmation finale (étape 2)                                    -->
<!-- ══════════════════════════════════════════════════════════════════════════ -->
<div *ngIf="showReviewConfirm"
  class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-[9999]"
  (click)="cancelReviewConfirm()">

  <div class="bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 p-6 transform transition-all"
    (click)="$event.stopPropagation()">

    <!-- Icône -->
    <div class="flex justify-center mb-4">
      <div class="w-16 h-16 rounded-full flex items-center justify-center"
        [ngClass]="reviewDecision === 'APPROVED' ? 'bg-green-100' : 'bg-red-100'">
        <svg *ngIf="reviewDecision === 'APPROVED'" class="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
        </svg>
        <svg *ngIf="reviewDecision === 'REJECTED'" class="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </div>
    </div>

    <!-- Titre -->
    <h3 class="text-xl font-bold text-gray-900 text-center mb-2">
      {{ reviewDecision === 'APPROVED' ? 'Confirmer l\'approbation ?' : 'Confirmer le refus ?' }}
    </h3>

    <!-- Résumé -->
    <p class="text-gray-600 text-center mb-6" *ngIf="selectedLeave">
      Vous êtes sur le point de
      <span class="font-semibold" [ngClass]="reviewDecision === 'APPROVED' ? 'text-green-700' : 'text-red-700'">
        {{ reviewDecision === 'APPROVED' ? 'approuver' : 'refuser' }}
      </span>
      le congé de
      <span class="font-semibold text-gray-900">{{ getWorkerName(selectedLeave) }}</span>.
      Cette action ne pourra pas être annulée depuis l'interface.
    </p>

    <!-- Boutons -->
    <div class="flex gap-3">
      <button (click)="cancelReviewConfirm()"
        class="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium">
        Annuler
      </button>
      <button (click)="confirmReviewFinal()" [disabled]="isActioning"
        class="flex-1 px-4 py-2.5 text-white rounded-lg transition-colors font-medium disabled:opacity-50
               flex items-center justify-center gap-2"
        [ngClass]="reviewDecision === 'APPROVED' ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700'">
        <svg *ngIf="isActioning" class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
        </svg>
        {{ isActioning ? 'Traitement...' : 'Confirmer' }}
      </button>
    </div>
  </div>
</div>

<!-- ══════════════════════════════════════════════════════════════════════════ -->
<!--  MODALE — Approuver / Refuser                                             -->
<!-- ══════════════════════════════════════════════════════════════════════════ -->
<div *ngIf="showReviewModal"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
  (click)="onReviewBackdrop($event)">

  <div class="bg-white rounded-xl shadow-xl max-w-md w-full p-6">

    <!-- Icône -->
    <div class="flex justify-center mb-4">
      <div class="w-14 h-14 rounded-full flex items-center justify-center"
        [ngClass]="reviewDecision === 'APPROVED' ? 'bg-green-100' : 'bg-red-100'">
        <!-- Check -->
        <svg *ngIf="reviewDecision === 'APPROVED'" class="w-7 h-7 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
        </svg>
        <!-- Cross -->
        <svg *ngIf="reviewDecision === 'REJECTED'" class="w-7 h-7 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </div>
    </div>

    <!-- Titre -->
    <h3 class="text-lg font-bold text-gray-900 text-center mb-1">
      {{ reviewDecision === 'APPROVED' ? 'Approuver ce congé ?' : 'Refuser ce congé ?' }}
    </h3>

    <!-- Résumé -->
    <div *ngIf="selectedLeave"
      class="text-sm text-gray-600 text-center mb-4 px-4 py-2 bg-gray-50 rounded-lg">
      <p class="font-medium text-gray-800">{{ getWorkerName(selectedLeave) }}</p>
      <p>{{ formatDate(selectedLeave.startDate) }} → {{ formatDate(selectedLeave.endDate) }}
        <span class="text-gray-400">({{ selectedLeave.requestedDays }}j)</span>
      </p>
      <p *ngIf="selectedLeave.reason" class="text-gray-500 mt-0.5 italic">{{ selectedLeave.reason }}</p>
    </div>

    <!-- Erreur -->
    <div *ngIf="reviewError" class="bg-red-50 border border-red-300 text-red-700 text-sm px-3 py-2 rounded-lg mb-4">
      {{ reviewError }}
    </div>

    <!-- Commentaire manager -->
    <div class="mb-5">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        Commentaire
        <span *ngIf="reviewDecision === 'REJECTED'" class="text-red-500">*</span>
        <span *ngIf="reviewDecision === 'APPROVED'" class="text-gray-400 font-normal">(optionnel)</span>
      </label>
      <textarea [(ngModel)]="managerComment" rows="3"
        [placeholder]="reviewDecision === 'APPROVED' ? 'Ex : RAS' : 'Motif du refus...'"
        class="w-full px-3 py-2 border border-gray-300 rounded-lg resize-none text-sm
               focus:outline-none focus:ring-2 focus:border-transparent"
        [ngClass]="reviewDecision === 'APPROVED' ? 'focus:ring-green-500' : 'focus:ring-red-500'">
      </textarea>
    </div>

    <!-- Boutons -->
    <div class="flex gap-3">
      <button (click)="closeReviewModal()"
        class="flex-1 px-4 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium">
        Annuler
      </button>
      <button (click)="reviewLeaveRequest()" [disabled]="isActioning"
        class="flex-1 px-4 py-2.5 text-white rounded-lg transition-colors font-medium disabled:opacity-50
               flex items-center justify-center gap-2"
        [ngClass]="reviewDecision === 'APPROVED' ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700'">
        <svg *ngIf="isActioning" class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
        </svg>
        {{ isActioning ? 'Traitement...' : (reviewDecision === 'APPROVED' ? 'Approuver' : 'Refuser') }}
      </button>
    </div>
  </div>
</div>
